import { register, render } from 'timeago.js'
import { htmlLang } from './i18n/translations'
import { importWithRetry } from '@/utils/component-loader'

/* NOTE: This file is not involved with the timeAgo() method used in Vue components.
 *       It only looks for <abbr class="timeago"> elements and applies timeago to them.
 *       For the timeAgo() method, see helpers/time-ago-format.js */

const currentLocale = htmlLang()
let timeAgoLocale = ''

importWithRetry(() => import(`./timeago-mappings/${currentLocale}.js`))
  .then(module => {
    const moduleLocale = module.default.locale
    const timeagoModule = module.default.module

    register(moduleLocale, timeagoModule)
    timeAgoLocale = moduleLocale
    loadTimeAgo('abbr.timeago')
  })

function loadTimeAgo(selector) {
  const nodes = document.querySelectorAll(selector)
  if (nodes.length > 0) {
    render(nodes, timeAgoLocale)
  }
}
